import { Link } from "react-router-dom";

const VALUES = [
  { t: "Operator-first", d: "Built by people who've actually run locate operations — not pure tech generalists." },
  { t: "Field reality", d: "Every feature passes through one filter: will it actually work for a locator at 6 AM in the rain?" },
  { t: "Customer-shaped", d: "Configuration over customization. Adapt to your contracts without code." },
  { t: "Real-time truth", d: "Operations data should be live, not assembled into a deck every Friday." },
];

export default function About() {
  return (
    <section className="section-y relative">
      <div className="container-x">
        <div className="max-w-3xl reveal">
          <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#F97316] mb-3">About LocateOS</div>
          <h1 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight">
            We're modernizing locate operations from the ground up.
          </h1>
          <p className="mt-5 text-lg text-[#94A3B8] leading-relaxed">
            LocateOS gives utility locate teams one operating system to manage tickets, dispatch crews, capture proof, and turn every shift into real-time operational intelligence.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-5">
          {VALUES.map((v, i) => (
            <div key={v.t} className="reveal rounded-2xl glass p-7" style={{ transitionDelay: `${i * 70}ms` }}>
              <div className="font-mono text-xs uppercase tracking-widest text-[#F97316]">0{i + 1}</div>
              <h3 className="mt-2 font-display font-bold text-xl text-white">{v.t}</h3>
              <p className="mt-2 text-[#94A3B8] leading-relaxed">{v.d}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 reveal rounded-2xl glass p-8 md:p-10 text-center">
          <h3 className="font-display font-bold text-2xl md:text-3xl text-white">Ready to see LocateOS for your operation?</h3>
          <p className="mt-3 text-[#94A3B8] max-w-2xl mx-auto">
            We'll map it to your markets, customers, and field workflows — and show you the platform live.
          </p>
          <Link to="/demo" className="mt-6 inline-flex bg-[#F97316] hover:bg-[#ea580c] text-white font-semibold px-6 py-3 rounded-lg shadow-[0_8px_24px_rgba(249,115,22,0.4)]">
            Request a Demo
          </Link>
        </div>
      </div>
    </section>
  );
}
